/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import EventPageHeader from './navbar/header';
import EventPageFilters from './navbar/filters';
import { GET } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import Loader from '/client/src/components/Loader';
import GridType1 from './detail/listView/gridType1';
import GridType2or3 from './detail/listView/gridType2or3';

import './styles.scss';

type PropsType = {};

const EventPage = ({}: PropsType): React.Element<typeof React.Fragment> => {
  const _context = React.useContext(DefaultContainerContext);
  const profileId = _context.profileCurrent.id;
  const PaginatorCounter = 23;
  const presetedGridType = +window.localStorage.getItem('EventGridType');
  const [gridType, _setGridType] = React.useState(presetedGridType || 1);
  const [lazyCountSkip, setLazyCountSkip] = React.useState(0);
  const [lazyCountMax, setLazyCountMax] = React.useState(PaginatorCounter);
  const [isPendingUpdate, setIsPendingUpdate] = React.useState(false);
  const setGridType = (type: number) => {
    _setGridType(type);
    window.localStorage.setItem('EventGridType', type);
  };

  const wrapper = React.useRef();

  const [searchInput, setSearchInput] = React.useState('');
  const [searchType, setSearchType] = React.useState(_context.filterEventDashboard[0]);
  const [eventList, setEventList] = React.useState([]);
  const [collaboratorsList, setCollaboratorsList] = React.useState([]);
  const [transactionsList, setTransactionsList] = React.useState([]);
  const [idsEventList, setIdsEventList] = React.useState('');

  const URLS = {
    collaborators: '/api/v1/1/events/collaborators',
    transaction: '/api/v1/1/statistics/events/transaction',
    events: `/api/v1/1/merchants/${profileId}/events?skip_count=${0}&max_result_count=${PaginatorCounter}&show_collaborative_events=true`
  };


  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        await setAllData(response.data.result.items);
      }
    },
    []
  );

  const setAllData = async (response: {}) => {
    try {
      const items = response;

      setEventList(items);

      const _ids = _.map(items, (i: {}): string | number => i.id).join(',');

      if (_.size(_ids)) {
        setIdsEventList(_ids);

        try {
          const { result } = await GET(`${URLS.collaborators}?ids=${_ids}&is_active=true`);

          setCollaboratorsList([...collaboratorsList, ...result]);
        } catch (e) {
          console.error('cant get collaborators list');
        }

        try {
          const { result } = await GET(`${URLS.transaction}?ids=${_ids}`);

          setTransactionsList([...transactionsList, ...result]);
        } catch (e) {
          console.error('cant get transactions list');
        }
      }
    } catch (e) {
      console.error('cant get events list');
    }
  };

  const updateRequest = async () => {
    
   
    setIsPendingUpdate(true);
    setLazyCountSkip(lazyCountSkip + PaginatorCounter);
    setLazyCountMax(lazyCountMax + PaginatorCounter);

    const filterEventTypeValue =  `&event_status=${searchType}`;
    const filterEventNameValue = `&event_name=${searchInput}`;
    console.log('###UpdateRequest. SearchType', searchType, 'filterValue', filterEventTypeValue, 'SearchINput', filterEventNameValue);

    const apiUrl =  `/api/v1/1/merchants/${profileId}/events`;

    // eslint-disable-next-line
    URLS.events = `${apiUrl}?skip_count=${lazyCountSkip + PaginatorCounter}&max_result_count=${PaginatorCounter}&show_collaborative_events=true${filterEventTypeValue}${filterEventNameValue}`;

    const events = await GET(`${URLS.events}`);

    setEventList([
      ...eventList,
      ...events.result.items
    ]);
    setIsPendingUpdate(false);

    const _ids = _.map(events.result.items, (i: {}): string | number => i.id).join(',');

    if (_.size(_ids)) {
      setIdsEventList(_ids);

      try {
        const collaborators = await GET(`${URLS.collaborators}?ids=${_ids}&is_active=true`);

        setCollaboratorsList([
          ...collaboratorsList,
          ...collaborators.result
        ]);
      } catch (e) {
        console.error('cant get collaborators list');
      }

      try {
        const transaction = await GET(`${URLS.transaction}?ids=${_ids}`);

        setTransactionsList([
          ...transactionsList,
          ...transaction.result
        ]);
      } catch (e) {
        console.error('cant get transactions list');
      }
    }
  };

  const handleLazyLoad = async () => {
    
  const container = document.querySelector('.event-list .row') || document.querySelector('.event-list');

    if (!container) {
      return;
    } 

    const lastEl = container.lastChild;
    const lastElCoords = !_.isNull(lastEl) ? lastEl.getBoundingClientRect() : null;

     if (!_.isNull(lastElCoords) && lastElCoords.bottom < window.innerHeight && !isPendingUpdate) {
       await updateRequest();
      }
  };

  const setFilter = async (param: number | string, by: string): any => {
    try {
      let url = URLS.events;

      if (by === 'type') {
        setSearchType(param);
      }

      CssPinner(wrapper.current, true);

      if (by === 'input') {
        url = `${URLS.events}&event_name=${param}${searchType !== 0 ? `&event_status=${searchType}` : ''}`;
      }

      if (by === 'type') {
        url = `${URLS.events}&event_status=${param}${!!_.size(searchInput) ? `&event_name=${searchInput}` : ''}`;
      }

      const { result } = await GET(url);
      const items = result.items;

      setAllData(items);

      CssPinner(wrapper.current, false);
    } catch (e) {
      console.log(e);
      console.error('Cant get events list by type filter');
      CssPinner(wrapper.current, false);
    }
  };
  /**
   * searchType: 1 - all events, 2 - active events, 3 - inactive events
   */

  return (
    <React.Fragment>
      <div
        className="sparxo-router-content"
        onScroll={(): void => handleLazyLoad()}
        style={{ maxHeight: '100vh', overflow: 'auto' }}
      >
        <div className='sparxo-page-container EventPage' ref={wrapper}>
          <EventPageHeader
            gridType={gridType}
            setGridType={setGridType}
          />

          <EventPageFilters
            searchInput={searchInput}
            searchType={searchType}
            setSearchInput={setSearchInput}
            setFilter={setFilter}
          />

          <section className='event-list'>
            <Loader
              url={`${URLS.events}${searchType !== 0 ? `&event_status=${_context.filterEventDashboard[0]}` : ''}`}
              onLoaded={handleLoaded}
            >
              {gridType === 1 ?
                <GridType1
                  eventList={eventList}
                  collaboratorsList={collaboratorsList}
                  transactionsList={transactionsList}
                /> :
                null
              }

              {gridType === 2 || gridType === 3 ?
                <GridType2or3
                  type={gridType}
                  eventList={eventList}
                  collaboratorsList={collaboratorsList}
                  transactionsList={transactionsList}
                  idsEventList={idsEventList}
                  setEventList={setEventList}
                /> :
                null
              }
            </Loader>

            {isPendingUpdate &&
              <div className='csspinner' />
            }
          </section>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EventPage;
